export const BlackListDataKey = 'blackList.data'
